// src/state/globalStore.js
import { create } from 'zustand';
import { supabase } from '../config';

export const useGlobalStore = create((set, get) => ({
  // --- STATE ---
  user: null,
  userProfile: null,
  loading: true,

  // --- ACTIONS ---
  initUser: async () => {
    try {
      const { data: { user: authUser } } = await supabase.auth.getUser();
      if (authUser) {
        set({ user: authUser });
        // Load user profile
        await get().loadUserProfile(authUser.id);
      }
    } catch (error) {
      console.error('Error loading user:', error);
    } finally {
      set({ loading: false });
    }
  },

  loadUserProfile: async (userId) => {
    try {
      const { data, error } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('id', userId)
        .single();

      if (error && error.code !== 'PGRST116') { // PGRST116 is "not found"
        console.error('Error fetching user profile:', error);
        return null;
      }

      set({ userProfile: data });
      return data;
    } catch (error) {
      console.error('Error fetching user profile:', error);
      return null;
    }
  },
}));
